import { render, staticRenderFns } from "./SampleEdit.vue?vue&type=template&id=5a2fdd84&scoped=true"
import script from "./SampleEdit.vue?vue&type=script&lang=js"
export * from "./SampleEdit.vue?vue&type=script&lang=js"
import style0 from "./SampleEdit.vue?vue&type=style&index=0&id=5a2fdd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fdd84",
  null
  
)

export default component.exports